import axios from "axios";

const baseURL = "https://fiberfinder.it/api";

export default axios.create({
  baseURL,
});